import Vue from 'vue'
import Router from 'vue-router'
import weChat from '@/assets/scripts/wechat';
import Func from "@/assets/scripts/func"
import Venue from '@/pages/Venue'
import VenueInfo from '@/pages/VenueInfo'
import VenueInfo2 from '@/pages/VenueInfo2'
import VenueInfo3 from '@/pages/VenueInfo3'
import CourseList from '@/pages/CourseList'
import CourseItem from '@/pages/CourseItem'
import CourseClass from '@/pages/CourseClass'
import CourseClassAlone from '@/pages/CourseClassAlone'
import CycleList from '@/pages/CycleList'
import CycleItem from '@/pages/CycleItem'
import CoachItem from '@/pages/CoachItem'
import CoachCourseItem from '@/pages/CoachCourseItem'
import CoachList from '@/pages/CoachList'
import Login from '@/pages/Login'
import My from '@/pages/My'
import MyCardList from '@/pages/MyCardList'
import MyCardItem from '@/pages/MyCardItem'
import OrderList from '@/pages/OrderList'
import ManageOrderList from '@/pages/ManageOrderList'
import OrderView from '@/pages/OrderView'
import ManageOrderView from '@/pages/ManageOrderView'
import OrderListRepeat from '@/pages/OrderListRepeat'
import ManageOrderListRepeat from '@/pages/ManageOrderListRepeat'
import Wallet from '@/pages/Wallet'
import SignContract from '@/pages/SignContract'
import SignCoach from '@/pages/SignCoach'
import ClubEntry from '@/pages/ClubEntry'
import ClubEnteredList from '@/pages/ClubEnteredList'
import CoachEntry from '@/pages/CoachEntry'
import CourseAppointment from '@/pages/CourseAppointment'
import MyReserved from '@/pages/MyReserved'
import CourseListManage from '@/pages/CourseListManage'
import MyCourseList from '@/pages/MyCourseList'
import CoachCourseManage from '@/pages/CoachCourseManage'
import CourseClassManage from '@/pages/CourseClassManage'
import CourseItemManage from '@/pages/CourseItemManage'
import coachCourseAdd from '@/pages/coachCourseAdd'
import courseItemAdd from '@/pages/courseItemAdd'
import Evaluation from '@/pages/Evaluation'
import Help from '@/pages/Help'
import ScanCode from '@/pages/ScanCode'
import ScanCodeWriteOff from '@/pages/ScanCodeWriteOff'
import clubLamp from '@/pages/clubAdmin/lampControl/index'
import buyLampSys from '@/pages/clubAdmin/lampControl/buyLampSys'
import bindLamp from '@/pages/clubAdmin/lampControl/bindLamp'
import lampBindResult from '@/pages/clubAdmin/lampControl/bindResult'

import Manage from '@/pages/manage/Manage'
import ManageCoach from '@/pages/manage/ManageCoach'
import StaffList from '@/pages/manage/StaffList'
import StaffAdd from '@/pages/manage/StaffAdd'
import StaffEdit from '@/pages/manage/StaffEdit'
import CardList from '@/pages/manage/CardList'
import CardAdd from '@/pages/manage/CardAdd'
import MCoachList from '@/pages/manage/CoachList'
import MCoachAdd from '@/pages/manage/CoachAdd'
import MCoachEdit from '@/pages/manage/CoachEdit'
import PrivateCourseList from '@/pages/manage/PrivateCourseList'
import PrivateCourseAdd from '@/pages/manage/PrivateCourseAdd'
import PrivateCourseTimetable from '@/pages/manage/PrivateCourseTimetable'
import MonthCourseList from '@/pages/manage/MonthCourseList'
import MonthCourseAdd from '@/pages/manage/MonthCourseAdd'
import Class from '@/pages/manage/Class'
import ClassDetail from '@/pages/manage/ClassDetail'
import SetClub from '@/pages/manage/SetClub'
import SetClubInfo from '@/pages/manage/SetClubInfo'
import SetClubStore from '@/pages/manage/SetClubStore'
import SetProductList from '@/pages/manage/SetProductList'
import SetProductAdd from '@/pages/manage/SetProductAdd'


Vue.use(Router);
const router = new Router({
  // mode: 'history',
  // base: '/venue/',
  routes: [
    {
      path: '*',
      component: Venue,
      meta: {
        title: '俱乐部',
      }
    }, {
      path: '/cid/:clubId',
      name: 'venue',
      component: Venue,
      meta: {
        title: '俱乐部',
      }
    }, {
      path: '/venueinfo/:clubid',
      name: 'venueinfo',
      component: VenueInfo,
      meta: {
        title: '俱乐部说明'
      }
    }, {
      path: '/venueinfo2',
      name: 'venueinfo2',
      component: VenueInfo2,
      meta: {
        title: '预约说明'
      }
    }, {
      path: '/venueinfo3',
      name: 'venueinfo3',
      component: VenueInfo3,
      meta: {
        title: '教练等级说明'
      }
    }, {
      path: '/help',
      name: 'help',
      component: Help,
      meta: {
        title: '帮助中心'
      }
    }, {
      path: '/courselist/:clubId',
      name: 'courselist',
      component: CourseList,
      meta: {
        title: '俱乐部课程列表'
      }
    }, {
      path: '/courseitem/:courseId',
      name: 'courseitem',
      component: CourseItem,
      meta: {
        title: '课程'
      }
    },
    {
      path: '/cyclelist/:clubId',
      name: 'cyclelist',
      component: CycleList,
      meta: {
        title: '练球卡列表'
      }
    }, {
      path: '/cycleitem/:courseId',
      name: 'cycleitem',
      component: CycleItem,
      meta: {
        title: '练球卡'
      }
    }, {
      path: '/courseappointment/:orderId/:itemId/:coachId/:type',
      name: 'courseappointment',
      component: CourseAppointment,
      meta: {
        title: '预约'
      }
    }, {
      path: '/myreserved/:clubId/:type',
      name: 'myreserved',
      component: MyReserved,
      meta: {
        title: '预约列表'
      }
    }, {
      path: '/coachlist/:clubId',
      name: 'coachlist',
      component: CoachList,
      meta: {
        title: '俱乐部教练'
      }
    }, {
      path: '/coachitem/:coachId',
      name: 'coachitem',
      component: CoachItem,
      meta: {
        title: '教练介绍'
      }
    }, {
      path: '/coachcourseitem/:courseId',
      name: 'coachcourseitem',
      component: CoachCourseItem,
      meta: {
        title: '私教课详情'
      }
    }, {
      path: '/coachcoursemanage/:courseId',
      name: 'coachcoursemanage',
      component: CoachCourseManage,
      meta: {
        title: '私教课详情管理'
      }
    },{
      path: '/courseitemmanage/:courseId',
      name: 'courseitemmanage',
      component: CourseItemManage,
      meta: {
        title: '团课详情管理'
      }
    }, {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登陆'
      }
    }, {
      path: '/my',
      name: 'my',
      component: My,
      meta: {
        title: '我的'
      }
    }, {
      path: '/mycardlist/:clubId/:cardType',
      name: 'mycardlist',
      component: MyCardList,
      meta: {
        title: '我的卡片'
      }
    }, {
      path: '/mycourselist/:clubId',
      name: 'mycourselist',
      component: MyCourseList,
      meta: {
        title: '我的私教课'
      }
    }, {
      path: '/mycarditem/:courseId',
      name: 'mycarditem',
      component: MyCardItem,
      meta: {
        title: '我的练球卡详情'
      }
    }, {
      path: '/courseclass',
      name: 'courseclass',
      component: CourseClass,
      meta: {
        title: '我的课程表'
      }
    }, {
      path: '/courseclassalone',
      name: 'courseclassalone',
      component: CourseClassAlone,
      meta: {
        title: '课程表'
      }
    }, {
      path: '/orderlist',
      name: 'orderlist',
      component: OrderList,
      meta: {
        title: '我的订单'
      },
      children: [
        {
          path: ':status',
          name: 'orderlistrepeat',
          component: OrderListRepeat
        }
      ]
    }, {
      path: '/manageorderlist',
      name: 'manageorderlist',
      component: ManageOrderList,
      meta: {
        title: '管理订单'
      },
      children: [
        {
          path: ':status',
          name: 'manageorderlistrepeat',
          component: ManageOrderListRepeat
        }
      ]
    }, {
      path: '/orderview/:orderId/:targettype',
      name: 'orderview',
      component: OrderView,
      meta: {
        title: '订单详情'
      }
    }, {
      path: '/manageorderview/:orderId/:targettype',
      name: 'manageorderview',
      component: ManageOrderView,
      meta: {
        title: '管理订单详情'
      }
    }, {
      path: '/wallet',
      name: 'wallet',
      component: Wallet,
      meta: {
        title: '财务管理'
      }
    }, {
      path: '/courselistmanage/:coachId/:roles',
      name: 'courselistmanage',
      component: CourseListManage,
      meta: {
        title: '课程管理'
      }
    }, {
      path: '/signcontract',
      name: 'signcontract',
      component: SignContract,
      meta: {
        title: '签约管理'
      }
    }, {
      path: '/courseclassmanage',
      name: 'courseclassmanage',
      component: CourseClassManage,
      meta: {
        title: '预约管理'
      }
    }, {
      path: '/clubentry',
      name: 'clubentry',
      component: ClubEntry,
      meta: {
        title: '俱乐部入驻'
      }
    }, {
      path: '/clubenteredlist',
      name: 'clubenteredlist',
      component: ClubEnteredList,
      meta: {
        title: '入驻俱乐部'
      }
    }, {
      path: '/coachentry',
      name: 'coachentry',
      component: CoachEntry,
      meta: {
        title: '教练申请认证'
      }
    }, {
      path: '/evaluation/:courseId/:courseType/:relateId/:orderId',
      name: 'evaluation',
      component: Evaluation,
      meta: {
        title: '评价'
      }
    },
    {
      path: '/scancode',
      name: 'scancode',
      component: ScanCode,
      meta: {
        title: '扫码核销'
      }
    },
    {
      path: '/scancodewriteoff',
      name: 'scancodewriteoff',
      component: ScanCodeWriteOff,
      meta: {
        title: '核销二维码'
      }
    },
    {
      path: '/clubLamp',
      name: 'clubLamp',
      component: clubLamp,
      meta: {
        title: '智能灯控系统'
      }
    },
    {
      path: '/buyLampSys',
      name: 'buyLampSys',
      component: buyLampSys,
      meta: {
        title: '智能灯控系统'
      }
    },
    {
      path: '/bindLamp',
      name: 'bindLamp',
      component: bindLamp,
      meta: {
        title: '智能灯控系统'
      }
    },
    {
      path: '/lampBindResult/:type',
      name: 'lampBindResult',
      component: lampBindResult,
      meta: {
        title: '智能灯控系统'
      }
    },
    {
      path: '/coachcourseadd',
      name: 'coachcourseadd',
      component: coachCourseAdd,
      meta: {
        title: '创建私教课'
      }
    },
    {
      path: '/courseitemadd',
      name: 'courseitemadd',
      component: courseItemAdd,
      meta: {
        title: '创建团课'
      }
    },
    {
      path: '/signcoach/:clubId',
      name: 'signcoach',
      component: SignCoach,
      meta: {
        title: '签约管理'
      }
    },
    {
      path: '/manage',
      name: 'manage',
      component: Manage,
      meta: {
        title: '场馆管理'
      }
    },
    {
      path: '/managecoach',
      name: 'managecoach',
      component: ManageCoach,
      meta: {
        title: '场馆管理'
      }
    },
    {
      path: '/stafflist',
      name: 'stafflist',
      component: StaffList,
      meta: {
        title: '员工管理'
      }
    },
    {
      path: '/staffadd',
      name: 'staffadd',
      component: StaffAdd,
      meta: {
        title: '员工管理'
      }
    },
    {
      path: '/staffedit',
      name: 'staffedit',
      component: StaffEdit,
      meta: {
        title: '员工编辑'
      }
    },
    {
      path: '/cardlist',
      name: 'cardlist',
      component: CardList,
      meta: {
        title: '练球卡管理'
      }
    },
    {
      path: '/cardadd',
      name: 'cardadd',
      component: CardAdd,
      meta: {
        title: '添加练球卡'
      }
    },
    {
      path: '/mcoachlist',
      name: 'mcoachlist',
      component: MCoachList,
      meta: {
        title: '教练管理'
      }
    },
    {
      path: '/mcoachadd',
      name: 'mcoachadd',
      component: MCoachAdd,
      meta: {
        title: '教练管理'
      }
    },
    {
      path: '/mcoachedit',
      name: 'mcoachedit',
      component: MCoachEdit,
      meta: {
        title: '教练编辑'
      }
    },
    {
      path: '/privatecourselist',
      name: 'privatecourselist',
      component: PrivateCourseList,
      meta: {
        title: '私教课管理'
      }
    },
    {
      path: '/privatecourseadd',
      name: 'privatecourseadd',
      component: PrivateCourseAdd,
      meta: {
        title: '私教课添加'
      }
    },
    {
      path: '/privatecoursetimetable',
      name: 'privatecoursetimetable',
      component: PrivateCourseTimetable,
      meta: {
        title: '定制课表'
      }
    },
    {
      path: '/monthcourselist',
      name: 'monthcourselist',
      component: MonthCourseList,
      meta: {
        title: '包月课管理'
      }
    },
    {
      path: '/monthcourseadd',
      name: 'monthcourseadd',
      component: MonthCourseAdd,
      meta: {
        title: '包月课添加'
      }
    },
    {
      path: '/class',
      name: 'class',
      component: Class,
      meta: {
        title: '课程表'
      }
    },
    {
      path: '/classdetail',
      name: 'classdetail',
      component: ClassDetail,
      meta: {
        title: '课表'
      }
    },
    {
      path: '/setclub',
      name: 'setclub',
      component: SetClub,
      meta: {
        title: '场馆配置'
      }
    },
    {
      path: '/setclubinfo',
      name: 'setclubinfo',
      component: SetClubInfo,
      meta: {
        title: '场馆基本信息'
      }
    },
    {
      path: '/setclubstore',
      name: 'setclubstore',
      component: SetClubStore,
      meta: {
        title: '场馆门店信息'
      }
    },
    {
      path: '/setproductlist',
      name: 'setproductlist',
      component: SetProductList,
      meta: {
        title: '产品管理'
      }
    },
    {
      path: '/setproductadd',
      name: 'setproductadd',
      component: SetProductAdd,
      meta: {
        title: '添加产品'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 滚动行为，当切换页面滚动条始终置顶
    return { x: 0, y: 0 };
  }
})

/**
 * 守卫需要登陆的页面
 */
let names = ['manage','managecoach','class','clubentry', 'coachentry', 'signcontract','signcoach', 'orderlist', 'orderview','mycourselist','orderlist','orderlistrepeat','scancode','scancodewriteoff']
router.beforeEach((to, from, next) => {
  let pageUrl = location.href
  if (pageUrl.indexOf('hash_path=') >= 0) {
    pageUrl = pageUrl.split('#')[0]
    let url = pageUrl.replace('?hash_path=', '#/')
    location.href = url.replace('&', '?')
  } else if (names.indexOf(to.name) !== -1 && !Func.isSetCookie('_ibl')) {
    // next({ name: 'login', query: { redirect: `/venue/#${to.path}` } })
    location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
  } else {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    weChat.wxShare(`${location.origin}/venue/#${to.path}`, to.meta.title, `${location.origin}/venue/#${to.path}`, '', 'https://www.buole.com/assets/v2/img/buole_icon.jpg');
    next()
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js